import React from "react";
import { ICheckBoxProps } from "@model/UIComponents.model";
import styles from './UiLibraryComponent.module.css';

const CheckBox: React.FC<ICheckBoxProps> = ({
  value,
  onChange,
  message,
  errorMessage,
  customStyle = "",
  messageAction,
  disableCheckBox,
}) => {
  return (
    <div
      className={styles.inputContainer}
      data-testid="checkbox-container"
    >
      <div
        className={styles.checkboxContainer}
        data-testid="checkbox-wrapper"
      >
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disableCheckBox}
          data-testid="checkbox-element"
          className={`${styles.checkboxElement} ${customStyle} ${
            disableCheckBox ? styles.checkBoxDisabled : ''
          }`}
        />
        <span
          className={styles.checkboxMessage}
          data-testid="checkbox-message"
          onClick={messageAction}
        >
          {message}
        </span>
      </div>
      {errorMessage && (
        <p
          className={styles.errorMessage}
          data-testid="checkbox-error"
        >
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default CheckBox;
